import { render } from "./HomeNavigation.vue?vue&type=template&id=516ccdd5"
import script from "./HomeNavigation.vue?vue&type=script&lang=js"
export * from "./HomeNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__